import { useAuthorizationStore } from "@shared/stores/authorization";
import { useSubscriptionsStore } from "@shared/stores/subscriptions";
import { type AuthorizationEntityType } from "@shared/types/common";
import { isRunningOnTour } from "@shared/utils/tour.ts";

type Permissions = {
  has: (
    permission: string,
    entityType?: AuthorizationEntityType,
    entityId?: string,
  ) => boolean;
};

type ResolveDefaultEntityId = (
  entityType: AuthorizationEntityType,
) => string | undefined;

const resolveDefaultEntityId: ResolveDefaultEntityId = (entityType) => {
  const subscriptionsStore = useSubscriptionsStore();
  switch (entityType) {
    case "subscription":
      return subscriptionsStore.currentSubscriptionNumber;
    case "payment_account":
      return subscriptionsStore.currentSubscription?.paymentAccountNumber;
    default:
      return undefined;
  }
};

export const permissions: Permissions = {
  has: (permission, entityType = "subscription", entityId) => {
    if (isRunningOnTour()) {
      return true;
    }

    const resolvedEntityId = entityId || resolveDefaultEntityId(entityType);
    if (!resolvedEntityId) {
      return false;
    }

    return useAuthorizationStore().hasPermission(
      resolvedEntityId,
      permission,
      entityType,
    );
  },
};
